export default [{
    path: '/families',
    name: 'families',
    component: () =>
        import ('@/views/pages/families/families-list/FamiliesList.vue'),
    meta: {
        pageTitle: 'Families',
        breadcrumb: [{
            text: 'Families',
            active: true,
            to:'/families'
        }, ],
        resource: 'family',
        action: 'read',
    },
},
// {
//     path: '/families/view/:id',
//     name: 'families-view',
//     component: () =>
//         import ('@/views/pages/families/families-view/FamilyView.vue'),
//     meta: {
//         pageTitle: 'View family',
//         breadcrumb: [
//         {
//             text: 'Families',
//             to: '/families'
//         },{
//             text: 'View',
//             active: true,
//         },],
//         resource: 'family',
//         action: 'read',
//     },
// },
{
    path: '/families/edit/:id',
    name: 'families-edit',
    component: () =>
        import ('@/views/pages/families/families-edit/FamilyEdit.vue'),
    meta: {
        pageTitle: 'Edit family',
        breadcrumb: [
        {
            text: 'Families',
            to: '/families',
        },
        {
            text: 'Edit',
            active: true,
        } ],
        resource: 'family',
        action: 'read',
    },
},
{
    path: '/families/add',
    name: 'families-add',
    component: () =>
        import ('@/views/pages/families/families-add/FamilyAdd.vue'),
    meta: {
        pageTitle: 'Create family',
        breadcrumb: [
        {
            text: 'Families',
            to: '/families',
        },
        {
            text: 'Add',
            active: true,
        }
        ],
        resource: 'family',
        action: 'read',
    },
}
]
